import { CustomModalConfig } from './../../component/modal/custom-modal.config.interface';
import { CustomModalService } from './../../component/modal/custom-modal.service';
import { Component, OnInit, ViewChild, OnChanges, Input, Output, EventEmitter    } from '@angular/core';
import { formatDate } from '@angular/common';
import { ModalDirective } from 'ngx-bootstrap/modal'; // Modal
import { RequestService } from '../../service/api/request.service';
import { StorageService } from '../../service/storage/storage.service';
import { ShareDataService } from '../../service/share-data/share-data.service';
import { Router } from '@angular/router';
import { UtilService } from '../../service/Util/Util';
import { document } from 'ngx-bootstrap/utils';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit , OnChanges{
  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  @Input() continueBooking : boolean
  @Input() selectedStudents : []
  @Input() studentResults : []
  @Input() stackRoute : []
  @Input() exceptionDays : []
  @Input() calendarOption = {
    bookingMode:{
      routeType : '',
      BookingType : '',
      changeMode : true
    },
    dateRangeSelected : {}
  }
  @Input() mode = ""
  @Input() id = ""; // define a unig ID per page
  @Output() setContinueBooking = new EventEmitter<any>();
  // AdHoc Feature //
  @Input()  AdHocWaiting : any;
  @Output() setAdHocWaiting = new EventEmitter<any>();
  @Input() paymentAvailable : boolean 
  @Input() contractPrice : any
  @Output() setDisableConfirmBooking = new EventEmitter<any>();
  @Output() account_id = new EventEmitter<number>()?? 0;


  // existing code
  
  // Extra  - Anymore option , data , anything - please send to extra//
  @Input() extras : any;

  termConditions:string;
  requestHeader : any;
  requestHeaderLoginToken : any;
  disableCheckbox = false;
  parentName = "";
  accepted: Boolean = true;
  disableConfirmTerm: Boolean = true;
  configModal: CustomModalConfig;
  configModalWarning: CustomModalConfig;
  configModalSuccess: CustomModalConfig;
  configPaynowModal: CustomModalConfig;
  accountName;

  requestData = [];
  token;
  term = {
    text : "Full Name"
  };
  checkedTermAdnCondition = true;
  // payment mothod //
  paymentMethod:any = [];
  selectedPaymentMethod = {};
  dateEndRoute = "";
  contractExceptionDay = "";
  balance = 0;
  deposit = 0;
  balanceSurCharge = 0;
  jobID = 0;
  setting = {}
  currency = '';
  isPriceContract = true;
  ischeckedTerm = false;
  _contractPrice = 0;
  disableConfirmPaymentTerm: Boolean = true;

  constructor(
    private requestService : RequestService,
    private storageService : StorageService,
    private customModalService: CustomModalService,
    private router: Router,
    private shareDataService: ShareDataService,
    private utilService : UtilService
  ) {
      this.configModal = {
        title: 'Transport Terms and Conditions',
        content: '',
        type: 'primary',
        backdrop : 'static'
      }
      this.configModalWarning = {
        title: 'WARNING',
        content: '',
        type: 'warning',
        backdrop : 'static'
      }
      this.configModalSuccess = {
        title: 'SUCCESS',
        content: '',
        type: 'success',
        backdrop : 'static'
      }
      this.configPaynowModal = {
        title: 'Payment',
        content: '',
        type: 'primary',
        backdrop : 'static'
      }
    }

  async ngOnInit(){
    let userlogin = await this.storageService.getStorage('user');
    if(userlogin){
      userlogin = JSON.parse(userlogin);
      this.accountName = userlogin.user.email;
    }
    let parentApi =  this.requestService.getParentAPI();
    let body = parentApi.routeOption.sendEmail;
    console.log("ngOnInit parentApi calendarOption",parentApi, body, userlogin, this.calendarOption)
    let termRes = await parentApi.get(parentApi.route.termAndCondition, "", parentApi.requestSecret())
    if(termRes['result'][0]){
      this.termConditions = termRes['result'][0]['attr_value'];
    }
    
    // Defau;t value using on every mode //
    // let parentApi = this.requestService.getParentAPI();
    
    let accountDetail = this.utilService.getEnv();
    let account_id = accountDetail['account_id'];
    this.account_id = account_id;
    let params = "?site_id="+accountDetail['site_id'];
    this.setting = await parentApi.get(
      parentApi.route.setting,
      params, 
      parentApi.requestSecret()
    );
    console.log("this.setting['company_detail']",this.setting['setting']['company_detail'], this.setting)
    this.currency = (this.setting && this.setting['setting']['company_detail'].length > 0) ? this.setting['setting']['company_detail'][0]['currency'] : '';
    
    let accountApi = this.requestService.getAccountAPI();
    let _paymentMethod = await accountApi.getPayment(account_id);
    this.paymentMethod = (_paymentMethod == null ? [] : _paymentMethod)
  }



  ngOnChanges() {
    this.parentName = "";
    this.disableConfirmTerm = true;
    this.checkedTermAdnCondition = true;
    this.disableCheckbox = false;
    this.disableConfirmPaymentTerm = true;
    this.ischeckedTerm = false;
    // this.accepted = true;
    console.log("ngOnChanges continueBooking",this.continueBooking, this.calendarOption, this.mode, this.requestData, this.stackRoute, this.exceptionDays, this.selectedStudents)
    if(this.continueBooking){
      console.log("exceptionDays", this.exceptionDays)
      console.log("stackRoute", this.stackRoute)
      console.log('term-con-modal'+this.id);
      this.customModalService.open('term-con-modal'+this.id)
      this.requestData = [];
      let priceContractPerPassenger = 0;
      this._contractPrice = 0;
      for(var i in this.selectedStudents){
        if(this.selectedStudents[i]){
          priceContractPerPassenger = priceContractPerPassenger + parseFloat(this.contractPrice);

          this.selectedStudents[i]
          let runningDays = this.exceptionDays[i];
          let routeType = ['am' , 'pm']
          let checkException = {
            'am':0,
            'pm':0,
          };
          routeType.forEach((type)=>{
                if(this.stackRoute[type] && this.stackRoute[type].length > 0){
                  let dateFrom  = this.extras['dateFrom']? this.extras['dateFrom'] : {};
                  let dateUntil = this.extras['dateUntil']? this.extras['dateUntil'] : {};
                  console.log("this.stackRoute[type]",this.stackRoute, this.stackRoute[type])
                  for(let r = 0 ; r < this.stackRoute[type].length; r++){
                         let exceptionRoute = '';
                         if(Object.keys(runningDays[type]).length > 0 && runningDays[type][r] !== 0){ 
                              let dayAmKey = Object.keys(runningDays[type][r]);
                              dayAmKey.forEach((dayKey)=>{
                                    if(!runningDays[type][r][dayKey]){
                                      exceptionRoute += dayKey + ',';
                                    }
                              })

                         }
                          exceptionRoute = exceptionRoute.substring(0, exceptionRoute.length - 1);
                          let datestart = null;
                          let dateend = null;
                          let dateKey = type+"|"+i+"|"+r;
                          if(this.mode == 'adhoc'){
                            let arrDateRangeSelected = {}
                            let arrDateSelected = this.calendarOption['dateRangeSelected'][type];
                            if(arrDateSelected.length > 0 ){
                              for(let i = 0; i<arrDateSelected.length;i++){
                                let from = arrDateSelected[i]['from']
                                let until = arrDateSelected[i]['until']
                                let dateFrom = from ? formatDate(from, 'yyyy-MM-dd','en-GB') : null;
                                let dateUntil = from ? formatDate(until, 'yyyy-MM-dd','en-GB') : null;
                                if(typeof arrDateRangeSelected['from'] == "undefined" || typeof arrDateRangeSelected['until'] == "undefined"){
                                  arrDateRangeSelected['from'] = []
                                  arrDateRangeSelected['until'] = []
                                }
                                arrDateRangeSelected['from'].push(dateFrom);
                                arrDateRangeSelected['until'].push(dateUntil);
                                
                              }
                              datestart = arrDateRangeSelected['from']
                              dateend = arrDateRangeSelected['until']
                            }

                          } else {
                            if(dateFrom[dateKey]){
                              datestart = formatDate(dateFrom[dateKey], 'yyyy-MM-dd','en-GB');
                            }
                            if(dateUntil[dateKey]){
                               dateend = formatDate(dateUntil[dateKey],'yyyy-MM-dd','en-GB');
                            }
                          }
                          
                          let amRoute = this.stackRoute[type][r];
                          this.dateEndRoute = amRoute['date_end'];
                          
                          this.contractExceptionDay = amRoute['except_day'];
                          this.jobID = amRoute['jobID'];
                          let singleData = {
                                              contractID: amRoute['contractID'],
                                              passenger_id:runningDays['passenger_id'], 
                                              job_id:amRoute['jobID'], 
                                              pickup_id:amRoute['pickup_id'], 
                                              dropoff_id:amRoute['dropoff_id'], 
                                              exception_days:exceptionRoute,
                                              pickup_order:amRoute['pickup_order'],
                                              dropoff_order:amRoute['dropoff_order'],
                                              bookDateFrom:datestart,
                                              bookDateUntil:dateend,
                                              route_type : type
                          };
                          this.requestData.push(singleData);

                  }

                }
          })
        }     
      }

      this._contractPrice = priceContractPerPassenger;
      console.log("request data => ", this.requestData, priceContractPerPassenger, this.contractPrice, this._contractPrice);
      console.log("Extras value", this.extras);
    }
  }

  cancelTerm() {
    this.setContinueBooking.emit(false);
    this.customModalService.close('term-con-modal'+this.id)
  }

  warningTerm() {
    this.setContinueBooking.emit(false);
    this.customModalService.close('term-con-modal-warning')
    let lateRoute = JSON.parse(this.storageService.getStorage("lateRoute"));
    let navigate = (lateRoute?.['isShowLateRoute']) ? lateRoute['job_name'] : 'home';
    this.router.navigate([navigate]); // when set to HomePage
  }

  successBook() {
    this.setContinueBooking.emit(false);
    this.customModalService.close('term-con-modal-success')
    let lateRoute = JSON.parse(this.storageService.getStorage("lateRoute"));
    let navigate = (lateRoute?.['isShowLateRoute']) ? 'children/'+lateRoute['job_name'] : 'children';
    this.router.navigate([navigate]); // when success go to children page
  }

  onScroll(event: any) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      this.disableCheckbox = false;
    }
  }

  checknameTerm(event) {
    this.parentName = event.target.value;
    // this.parentName = this.parentName.replace(/\s/g, '');
    this.allowBooking();
  }

  checkboxTerm(event) {
    this.checkedTermAdnCondition = event.target.checked;
    this.allowBooking();
  }
  allowBooking(){
    if(this.parentName.length > 3  && this.checkedTermAdnCondition && this.parentName.replace(/\s/g, '')!=''){
      this.disableConfirmTerm = false;
    }else{
      this.disableConfirmTerm = true;
    }
  }

  changeCheckedTerm(event) {
    this.ischeckedTerm = event.target.checked;
    this.allowPaymentTerm();
  }
  allowPaymentTerm(){
    if(this.ischeckedTerm){
      this.disableConfirmPaymentTerm = false;
    }else{
      this.disableConfirmPaymentTerm = true;
    }
  }

  async confirmTermLog(){
    let parentApi =  this.requestService.getParentAPI();
    var parent_name = this.parentName
    var data = []
      data.push({
        "parent_name":parent_name
      })
    let body = {"data" : data}
    let result = await parentApi.post(parentApi.route.termsLog, body, parentApi.requestHeaderUser());
    return result;
  } 
  
  async confirmTerm() {
    let result = await this.confirmTermLog();
    let parentApi =  this.requestService.getParentAPI();
    if (result['result'].length > 0) {
      
      this.customModalService.close('term-con-modal'+this.id)  
      if (this.stackRoute['am'].length > 0) {
        var routeInfo = this.stackRoute['am'][0]
      }
      if (this.stackRoute['pm'].length > 0) {
        var routeInfo = this.stackRoute['pm'][0]
      }
      
      console.log("paymentAvailable",this.paymentAvailable, this._contractPrice, this.paymentMethod)
      let isPaymentAvailable = false;
      if(this.paymentAvailable && this._contractPrice > 0 && (this.paymentMethod && this.paymentMethod.length > 0 && this.paymentMethod[0]['payment_method'])){
        isPaymentAvailable = true;
      }
      let body = {"data" : this.requestData , "mode" : this.mode , "contractPassengerTemp": isPaymentAvailable }
      let submitPassengers = await parentApi.post(parentApi.route.insertPassengerToRoute, body, parentApi.requestHeaderUser()) // Default API
      if(submitPassengers['result']['status'] != 0){
        // Success then go to Children page
        
        if(isPaymentAvailable){
          this.paymentModal('contract')
        } else {
          this.bookingDoneModal()
        }


      }else if(submitPassengers['result']['status'] == 0){
        // Warning Modal then Seat is full
        console.log("Seat is full");
        this.configModalWarning = {
          title: 'Warning',
          content: submitPassengers['result']['msg'],
          type: 'warning',
          backdrop : 'static',
          OkButtonText : 'OK',
          alignButton : 'center',
          showOkButton : true,
          OkButtonStyle: {
            'width': '100%',
            'background-color': 'var(--yellow)',
            'color': 'white'
          },
        }
        this.customModalService.open('term-con-modal-warning')
      }
    }
  }

  async submitPaynow(){

    let dataForm = {}
    let content : any;
    if(this.selectedPaymentMethod['payment_action'] == 'redirect'){
      let formSubmit = document.getElementById(this.selectedPaymentMethod['payment_name']+'submit');
      formSubmit.click();
    } else {
      let accountApi = this.requestService.getAccountAPI();
      dataForm['dataForm'] = this.requestData
      dataForm['payment_action'] = this.selectedPaymentMethod['payment_action'];
      dataForm['payment_url'] = this.selectedPaymentMethod['payment_url'];
      dataForm['method'] = this.selectedPaymentMethod['payment_method'];
      dataForm['jobID'] = this.jobID;
      dataForm['isPriceContract'] = this.isPriceContract;
      dataForm['email'] = this.accountName;
      dataForm['parentPortal'] = true;
      content = await accountApi.makePayment(dataForm);

      console.log("this.selectedPaymentMethod['payment_method'] content",content, this.selectedPaymentMethod['payment_method'])
    }

    
    
    if(this.mode == 'adhoc'){
      this.confirmAdhocTerm(content)
    } else {
      // this.bookingDoneModal(content)
    }
  }

  async closeSubmitPaynow(){
    console.log("closeSubmitPaynow")
    this.customModalService.close('success-paynow-modal');
    let body = {"data" : this.requestData}
    let parentApi =  this.requestService.getParentAPI();
    let submitPassengers = await parentApi.post(parentApi.route.removePassengerToRouteTemp, body, parentApi.requestHeaderUser()) // Default API
    this.setDisableConfirmBooking.emit(true);
  }

  async confirmAdhocTerm(content=""){
    let result = await this.confirmTermLog();
    console.log(result);
    this.customModalService.close('term-con-modal'+this.id)  
    // this.customModalService.open('exception-modal')  
    if (result['result'].length > 0){
      console.log("888888");
      if(this.AdHocWaiting.length > 0){
        this.AdHocWaiting.forEach((val,index)=>{
          if(!!!val['confirmTerm']){ 
            val['confirmTerm'] = true
            if(content){
              val['content'] = content
            }
          }
          this.AdHocWaiting[index] = val;
          
        })
      }
      //this.setContinueBooking.emit(false);
      this.setAdHocWaiting.emit(this.AdHocWaiting);
      console.log("Emit Not working");
    }
  }

  confirmBookingAdhoc(){
    if(this.paymentAvailable && this._contractPrice > 0){
      this.paymentModal('adhoc')
    } else {
      this.confirmAdhocTerm()
    }
  }

  async paymentModal(mode){
    this.customModalService.close('term-con-modal'+this.id)  
    // Payment Box //
    // let accountApi = this.requestService.getAccountAPI();
    // this.paymentMethod = await accountApi.getPayment();

    if(!this.paymentMethod[0]['payment_method']){
      switch (mode) {
        case 'contract':
          this.bookingDoneModal()
          break;
        case 'adhoc':
          this.confirmAdhocTerm()
          break;
        
        default:
          this.bookingDoneModal()
          break;
      }

      return true;
    }

    this.calculatePayment()
    this.configPaynowModal = {
      title: 'Payment',
      content: '',
      type: 'success',
      backdrop : 'static',
      // showOkButton : true,
      // OkButtonText : 'Pay now',
      // alignButton : 'center',
      // OkButtonStyle: {
      //       'width': '100%',
      //       'background-color': 'var(--green)',
      //       'color': 'white'
      //     }
    }
    this.customModalService.open('success-paynow-modal');
    
  }

  calculatePayment(){
    // set default selected payment method
    if(this.selectedPaymentMethod && Object.keys(this.selectedPaymentMethod).length == 0){
      let found = [];
      console.log("this.paymentMethod",this.paymentMethod)
      if(this.paymentMethod && this.paymentMethod.length > 0){
        found = this.paymentMethod.filter((str) => {
          return 'Stripe'.toLowerCase().indexOf(str['payment_method'].toLowerCase()) >= 0; 
        })
      }
      

      if(found.length > 0){
        this.selectedPaymentMethod = found[0]
      }

    }

    /*  
        ** version studentsafe **
        - price on contract per passenger for the route.
        - That price calculate in PRP is just mock-up for show on UI
        - The actual price that is calculated will be at class.proceedpayment.php
    */
    if(this.mode != 'adhoc'){
      this.balance = this._contractPrice;
      this.balanceSurCharge = this.getPriceToPay(this.selectedPaymentMethod['payment_surcharge_val'], this.selectedPaymentMethod['payment_surcharge_per'], "")
      console.log("*balance price", this.balance, this.balanceSurCharge, this.selectedPaymentMethod, this._contractPrice, this.mode)
      return true;
    }


    let countBooking = {};
    for (let i = 0; i < this.requestData.length; i++) {
      let element = this.requestData[i];
      let bookDateFrom = element['bookDateFrom']
      let bookDateUntil = (element['bookDateUntil'] ? element['bookDateUntil'] : this.dateEndRoute);
      let arrBookDateFrom = bookDateFrom
      let arrBookDateUntil = bookDateUntil
      if(!Array.isArray(bookDateFrom)){
        arrBookDateFrom = bookDateFrom.split(',');
      }
      if(!Array.isArray(bookDateUntil)){
        arrBookDateUntil = bookDateUntil.split(',');
      }

      let exception_days = element['exception_days']+this.contractExceptionDay;
      let assign_day = this.checkContractAssignDay(exception_days);
      let j = 0;
      
      for (let k = 0; k < arrBookDateFrom.length; k++) {
        // let index = arrBookDateFrom[k];
        let dateForm = arrBookDateFrom[k];
        let dateUntil = arrBookDateUntil[k];

        // this.minDateAM.setDate(this.minDateAM.getDate()+1);
        while (new Date(dateForm) <= new Date(dateUntil)) {
          let d = new Date(dateForm);
          if(typeof countBooking[dateForm] == "undefined"){
            countBooking[dateForm] = 0
          }

          var filteredArray = assign_day.filter((str)=>{
            return String(d).toLowerCase().indexOf(str.toLowerCase()) >= 0; 
          });
          if(filteredArray.length > 0){
            countBooking[dateForm] = parseInt(countBooking[dateForm]) + 1;
          }
          dateForm = new Date(dateForm)
          dateForm = formatDate(dateForm.setDate(dateForm.getDate()+1), 'yyyy-MM-dd','en-GB');
          j++;
        }
      }
    }

    let sumValues = this.sumValue(countBooking)
    this.balance = this._contractPrice * sumValues;
    this.balanceSurCharge = this.getPriceToPay(this.selectedPaymentMethod['payment_surcharge_val'], this.selectedPaymentMethod['payment_surcharge_per'], "")
    console.log("*balance price", this.balance, this.balanceSurCharge, this.selectedPaymentMethod, sumValues, countBooking, this._contractPrice)
  }

  getPriceToPay(surcharge_val, surcharge_per, price1=""){
    let bank_sur_val = parseFloat(surcharge_val);
    let bank_sur_per = parseFloat(surcharge_per);
    let pc = 0;
    if (bank_sur_per > 0){pc = 1 + (bank_sur_per / 100);}else{pc = 1;}
    if(price1 == 'deposit'){
      let price = this.depositPrice(pc, bank_sur_val)
      // return parseFloat(price).toFixed(2);
      return Math.round(price * 100) / 100;
    }
    // return parseFloat((this.balance * pc + bank_sur_val)).toFixed(2);
    return Math.round((this.balance * pc + bank_sur_val) * 100) / 100;
  }
  depositPrice(pc =0,sur_val=0){
      let price = this.deposit * pc + sur_val;
      return price;
  }
  sumValue( obj ) {
    var sum = 0;
    for( var el in obj ) {
      if( obj.hasOwnProperty( el ) ) {
        sum += parseFloat( obj[el] );
      }
    }
    return sum;
  }
      
  checkContractAssignDay(exception_days) {
    let exceptDays = exception_days;
    let c = 0;
    let MatchDay = {
        0 : 'Sun',
        1 : 'Mon',
        2 : 'Tue',
        3 : 'Wed',
        4 : 'Thu',
        5 : 'Fri',
        6 : 'Sat'
    };
    let contractMathDay = [];
    for (let j=0; j < 7; j++) { 
        let found = exceptDays.indexOf(j);
        if(found == -1){
          contractMathDay.push(MatchDay[j]);
        } 
    }
    if(contractMathDay.length == 0){
        contractMathDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    }

    return contractMathDay;
   
  }

  bookingDoneModal(content=""){
    // booking done show modal
    console.log("Booking done show massage");
    let _content = 'Thank you, your Booking is now complete and you will receive an email confirmation.';
    if(content){
      _content = content
    }
    this.configModalSuccess = {
      title: 'Success',
      content: _content,
      type: 'success',
      backdrop : 'static',
      OkButtonText : 'Finish',
      alignButton : 'center',
      showOkButton : true,
      OkButtonStyle: {
        'width': '100%',
        'background-color': 'var(--green)',
        'color': 'white'
      },
    }
    console.log("done msg ",this.configModalSuccess.content);
    // if(this.configModalSuccess.content != ''){
      this.customModalService.open('term-con-modal-success');
    // }
  }

  selectedPayment(e) {
    this.selectedPaymentMethod = e.value;
    this.calculatePayment()
    console.log("e selectedPayment :: ",e)
  }
}
